import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Control } from "react-hook-form";

import { UseFormSetDefault } from "@/hooks/useSetDefault";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";
import { TalentDetails } from "@aglocal/schema/Interview";

export interface SkillsCommentsFieldProps {
  details: Readonly<TalentDetails> | undefined;
  control: Control<PostMeetingFormWithSummary>;
  setDefault: UseFormSetDefault<PostMeetingFormWithSummary>;
}

export default function SkillsCommentsField({
  details,
  control,
  setDefault,
}: SkillsCommentsFieldProps) {
  const { $t } = useIntl();
  const defaultValue = details?.skillsComments ?? "";

  useEffect(() => {
    setDefault("skillsComments", defaultValue);
  }, [defaultValue, setDefault]);

  return (
    <TextField
      name="skillsComments"
      label={$t(FIELD_LABELS.skillsComments)}
      control={control}
    />
  );
}
